module.exports = __webpack_public_path__ + "static/media/DrumsScore1-KELsMUSIC.460b62ec.jpg";